<script setup lang="ts">
import { useLanguage } from '#composables/useLanguage';
import { config } from '#config/configuration';
import { C4FunctionalNotice, FunctionalNoticeType } from '@c4-links/vue3-links-components';
import type { CountryType } from '@carrefour-gcs/shared';
import { computed } from 'vue';

const { userCountry = undefined, isExportCsv } = defineProps<{
  userCountry?: CountryType;
  isExportCsv: boolean;
}>();

const { t } = useLanguage();

const hasDocForCountryKey = computed(() => userCountry && config.exportCsvDocUrl[userCountry]);

const redirectToLink = () => {
  if (userCountry && config.exportCsvDocUrl[userCountry]) {
    const exportCsvDocUrl = config.exportCsvDocUrl[userCountry];
    window.open(exportCsvDocUrl, '_blank');
  }
};
</script>
<template>
  <div class="flex flex-col">
    <C4FunctionalNotice :closable="false" :type="FunctionalNoticeType.SUCCESS" class="whitespace-pre-line"
      ><template #body>
        <p>{{ t('dataTableExportPopIn.successText') }}</p>
      </template>
    </C4FunctionalNotice>

    <div v-if="hasDocForCountryKey && isExportCsv" class="flex items-center text-primary mt-4 text-sm">
      <span class="cursor-pointer items-top font-bold" @click="redirectToLink">
        {{ t('dataTableExportPopIn.exportDocUrl.button.title') }}</span
      >
    </div>
  </div>
</template>
